import axios, { AxiosRequestConfig } from "axios";

export const client = axios.create({
  baseURL: `${process.env.NEXT_PUBLIC_API_ENDPOINT}`,
} as AxiosRequestConfig);
